import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import heroImage from './image00002.jpeg';
import { Waves, Gift } from 'lucide-react';

const Hero = () => {
  return (
    <div className="relative w-full overflow-hidden" style={{ height: '100vh', marginTop: '-80px', touchAction: 'pan-y' }}>
      {/* Fixed Background Image with Blur */}
      <div className="absolute inset-0 overflow-hidden" style={{ WebkitTransform: 'translateZ(0)', transform: 'translateZ(0)' }}>
        <img
          src={heroImage}
          alt=""
          className="w-full h-full object-cover"
          style={{
            filter: 'blur(2px)',
            transform: 'scale(1.1)',
            WebkitTransform: 'scale(1.1) translateZ(0)',
            willChange: 'transform',
            pointerEvents: 'none'
          }}
        />
      </div>
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-900/40 via-blue-800/50 to-blue-900/70"></div>
      
      {/* Animated Ocean Waves */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg className="w-full h-32" viewBox="0 0 1440 320">
          <path 
            fill="rgba(255,255,255,0.1)" 
            d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            className="animate-wave"
          ></path>
          <path 
            fill="rgba(255,255,255,0.2)" 
            d="M0,256L48,261.3C96,267,192,277,288,272C384,267,480,245,576,224C672,203,768,181,864,192C960,203,1056,245,1152,261.3C1248,277,1344,267,1392,261.3L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            style={{ animationDelay: '2s' }}
            className="animate-wave"
          ></path>
        </svg>
      </div>
      
      {/* Content - Adjusted for navbar overlap */}
      <div className="relative z-10 flex items-center justify-center h-full pt-28 sm:pt-20">
        <div className="text-center text-white px-8 max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 text-cyan-300 mb-4 animate-fadeIn">
            <Waves className="w-6 h-6" />
            <span className="text-sm uppercase tracking-wider font-medium">Welcome to Paradise</span>
          </div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl mb-6 font-bold leading-tight animate-fadeIn font-serif">
            <span className="bg-gradient-to-r from-white to-cyan-100 bg-clip-text text-transparent">Oceanique</span>
            <br />
            <span className="text-3xl sm:text-4xl lg:text-5xl text-cyan-200">Medical Spa & Wellness</span>
          </h1>
          <p className="text-xl sm:text-2xl mb-8 text-blue-100 animate-fadeIn animation-delay-200 max-w-3xl mx-auto">
            Where the tranquility of the ocean meets cutting-edge aesthetic treatments for your ultimate transformation
          </p>
          <div className="flex flex-col gap-4 items-center justify-center animate-fadeIn animation-delay-400">
            <Link 
              to="/booking" 
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:from-blue-700 hover:to-cyan-700 w-full sm:w-auto justify-center"
            >
              <Waves className="w-5 h-5" />
              Book Your Experience
            </Link>
            <Link
              to="/services"
              className="inline-block bg-white/20 backdrop-blur-md text-white border-2 border-white/50 px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/30 transition-all duration-300 hover:scale-105 w-full sm:w-auto text-center"
            >
              Explore Treatments
            </Link>
            <a
              href="https://app.squareup.com/gift/MLT2WMJ6SJGPG/order"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-amber-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl transition-all duration-300 hover:scale-105 hover:from-yellow-600 hover:to-amber-600 w-full sm:w-auto justify-center"
            >
              <Gift className="w-5 h-5" />
              Gift Cards
            </a>
          </div>
        </div>
      </div>

      {/* Floating Elements */}
      <div className="absolute top-32 left-10 w-20 h-20 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-full blur-xl opacity-30 animate-float"></div>
      <div className="absolute top-52 right-20 w-32 h-32 bg-gradient-to-br from-cyan-400 to-blue-400 rounded-full blur-xl opacity-30 animate-float" style={{ animationDelay: '2s' }}></div>
      <div className="absolute bottom-40 left-20 w-24 h-24 bg-gradient-to-br from-blue-300 to-cyan-300 rounded-full blur-xl opacity-30 animate-float" style={{ animationDelay: '4s' }}></div>
    </div>
  );
};

export default Hero;